import React, { useRef } from 'react';

import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { BaseClose } from 'src/components/BaseClose';
import { BaseGenericModal } from 'src/components/BaseGenericModal';
import { EModalSize, EPredefinedModalIds } from 'src/constants/modals';
import { FormChangePassword } from 'src/pages/ResetPassword/FormChangePassword';
import { selectIsModalOpened } from 'src/redux/modals/modals.selectors';
import { closeModal } from 'src/redux/modals/modals.slice';
import { useAppDispatch } from 'src/redux/store';

import s from './ModalChangePassword.module.scss';
import { TModalChangePasswordProps } from './ModalChangePassword.types';

export const ModalChangePassword: React.FC<TModalChangePasswordProps> = ({
  resetId,
  resetKey,
  onClose,
}) => {
  const { t } = useTranslation();

  const modalRef = useRef<HTMLDivElement>(null);
  const dispatch = useAppDispatch();

  const isModalOpened = useSelector(selectIsModalOpened(EPredefinedModalIds.MODAL_CHANGE_PASSWORD));

  function handleCloseClick() {
    dispatch(closeModal(EPredefinedModalIds.MODAL_CHANGE_PASSWORD));
    onClose?.();
  }

  return (
    <>
      {isModalOpened && <div className={s.background} />}
      <BaseGenericModal
        className={s.modal}
        modalId={EPredefinedModalIds.MODAL_CHANGE_PASSWORD}
        size={EModalSize.L395}
        modalRef={modalRef}>
        <BaseClose className={s.closeBtn} onClick={handleCloseClick} />

        <div className={s.formsWrapper}>
          <header>
            <h1 className={s.heading}>{t('tooltips.RESET_PASSWORD')}</h1>
          </header>

          <FormChangePassword handleClose={handleCloseClick} {...{ resetId, resetKey }} />
        </div>
      </BaseGenericModal>
    </>
  );
};
